import React, { Component } from 'react';
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';

import Teeth from '../Teeth';
import TeethChart from '../TeethChart';

import { PlayCircle, StopCircle } from 'react-feather';

import 'rc-slider/assets/index.css';
import './history.css';

const Handle = Slider.Handle;

const marks = {
	0: '1.3.2015',
	1: '6.1.2016',
	2: '7.11.2016',
	3: '3.6.2017',
};

var karies = [];
karies.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);
karies.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);
karies.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);
karies.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);

var holes = [];

holes.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);
holes.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);
holes.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);
holes.push(
	Array.apply(null, Array(50)).map(function(x, i) {
		return Math.random() > 0.035;
	})
);

const handle = props => {
	const { value, dragging, index, ...restProps } = props;
	return (
		<Tooltip
			prefixCls="rc-slider-tooltip"
			overlay={value}
			visible={true}
			placement="top"
			key={index}
		>
			<Handle value={value} {...restProps} />
		</Tooltip>
	);
};

var interval = null;

class HistoryView extends Component {
	state = {
		imgNum: 0,
		updateCount: 0,
		holes: holes[0],
		karies: karies[0],
		playing: false
	};

	constructor(props) {
		super(props);
		this.change = this.change.bind(this);
	}

	componentDidMount() {
		// setInterval(this.interval.bind(this), 500);
	}

	change(v) {
		console.log('change', v);
		this.setState({
			imgNum: v,
			// imgNum: this.state.imgNum === 3 ? 0 : this.state.imgNum + 1,
		});
	}

	interval() {
		this.setState({
			imgNum: this.state.imgNum >= 3 ? 0 : this.state.imgNum + 1,
			updateCount: this.state.updateCount + 1,
		});
	}

	play() {
		if (interval) {
			clearInterval(interval);
			interval = null;
			this.setState({ play: false });
		} else {
			interval = setInterval(this.interval.bind(this), 500);
      this.setState({ play: true })
		}
	}

	render() {
		return (
			<div
				className="history-view"
				style={{ display: this.props.hide ? 'none' : 'block' }}
			>
				<div className="play-feature">
					<button class="play-btn" onClick={() => this.play()}>
            {this.state.play ? (
								<StopCircle />
              ) : (
								<PlayCircle />
              )
            }
					</button>
					<Slider
						max={3}
						marks={marks}
						onChange={this.change}
						value={this.state.imgNum}
						maximumTrackStyle={{
							backgroundColor: '#aaa',
							height: 10,
						}}
						minimumTrackStyle={{
							backgroundColor: '#aaa',
							height: 10,
						}}
						handleStyle={{
							borderColor: '#ff63a2',
							height: 28,
							width: 28,
							marginLeft: -14,
							marginTop: -9,
							backgroundColor: '#ff63a2',
						}}
						dotStyle={{
							borderColor: '#ff63a2',
							height: 10,
							width: 10,
							// marginLeft: -14,
							// marginTop: -20,
							backgroundColor: '#ff63a2',
						}}
						activeDotStyle={{
							borderColor: '#ff63a2',
							height: 10,
							width: 10,
							// marginLeft: -14,
							// marginTop: -9,
							backgroundColor: '#ff63a2',
						}}
					/>
				</div>

				<div style={{ display: 'flex', width: 900, margin: '0 auto' }}>
					<div className="teeth">
						<Teeth
							width={350}
							height={350}
							imgNum={this.state.imgNum}
						/>
						<Teeth width={350} height={350} imgNum={-1} />
					</div>
					<TeethChart
						className="teethchart"
						width={500}
						height={400}
						karies={karies[this.state.imgNum]}
						holes={holes[this.state.imgNum]}
						updateCount={this.state.updateCount}
					/>
				</div>
			</div>
		);
	}
}

export default HistoryView;



// WEBPACK FOOTER //
// ./src/components/HistoryView/index.js